"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var nativeProps_exports = {};
__export(nativeProps_exports, {
  resolveNativeProps: () => resolveNativeProps,
  resolveVeilColor: () => resolveVeilColor
});
module.exports = __toCommonJS(nativeProps_exports);
var import_react_native = require("react-native");
var import_curves = require("./curves");
var import_normalize = require("./normalize");
function resolveVeilColor(color) {
  if (color == null) return 0;
  var processed = (0, import_react_native.processColor)(color);
  return typeof processed === "number" ? processed : 0;
}
function resolveNativeProps(resolved, radius) {
  var _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7;
  var _resolved_top, _resolved_bottom, _resolved_left, _resolved_right, _resolved_top1, _resolved_bottom1, _resolved_left1, _resolved_right1;
  return {
    fadeTop: (_ref = (_resolved_top = resolved.top) === null || _resolved_top === void 0 ? void 0 : _resolved_top.size) !== null && _ref !== void 0 ? _ref : 0,
    fadeBottom: (_ref1 = (_resolved_bottom = resolved.bottom) === null || _resolved_bottom === void 0 ? void 0 : _resolved_bottom.size) !== null && _ref1 !== void 0 ? _ref1 : 0,
    fadeLeft: (_ref2 = (_resolved_left = resolved.left) === null || _resolved_left === void 0 ? void 0 : _resolved_left.size) !== null && _ref2 !== void 0 ? _ref2 : 0,
    fadeRight: (_ref3 = (_resolved_right = resolved.right) === null || _resolved_right === void 0 ? void 0 : _resolved_right.size) !== null && _ref3 !== void 0 ? _ref3 : 0,
    curveTop: (0, import_curves.serializeCurve)((_ref4 = (_resolved_top1 = resolved.top) === null || _resolved_top1 === void 0 ? void 0 : _resolved_top1.curve) !== null && _ref4 !== void 0 ? _ref4 : import_normalize.DEFAULT_CURVE),
    curveBottom: (0, import_curves.serializeCurve)((_ref5 = (_resolved_bottom1 = resolved.bottom) === null || _resolved_bottom1 === void 0 ? void 0 : _resolved_bottom1.curve) !== null && _ref5 !== void 0 ? _ref5 : import_normalize.DEFAULT_CURVE),
    curveLeft: (0, import_curves.serializeCurve)((_ref6 = (_resolved_left1 = resolved.left) === null || _resolved_left1 === void 0 ? void 0 : _resolved_left1.curve) !== null && _ref6 !== void 0 ? _ref6 : import_normalize.DEFAULT_CURVE),
    curveRight: (0, import_curves.serializeCurve)((_ref7 = (_resolved_right1 = resolved.right) === null || _resolved_right1 === void 0 ? void 0 : _resolved_right1.curve) !== null && _ref7 !== void 0 ? _ref7 : import_normalize.DEFAULT_CURVE),
    fadeRadius: radius !== null && radius !== void 0 ? radius : 0,
    mode: resolved.mode,
    blurRadius: resolved.blurRadius,
    frostProgression: resolved.frostProgression,
    overlayColor: resolved.mode === "blur" ? resolveVeilColor(resolved.color) : 0
  };
}
//# sourceMappingURL=nativeProps.js.map
